import styled, { StyledProps } from 'styled-components'
import { EModSize, IModSize } from '@ucheba/utils/helpers/styles/mod.types'
import { sm } from '@ucheba/utils/helpers/styles/mixins'

const Block = styled.div<StyledProps<IModSize>>`
  ${sm.mod(EModSize.medium)`
    & svg {
      width: 64px;
      height: 64px;
    }
  `};

  ${sm.mod(EModSize.small)`
    & svg {
      width: 48px;
      height: 48px;
    }
  `};
`

export default { Block }
